import type { DviInspection } from '../api/types';

const DRAFT = (id: string) => `dvi-draft-${id}`;
const PENDING = 'dvi-pending';

export function saveDraft(dvi: DviInspection): void {
  try {
    localStorage.setItem(DRAFT(dvi.id), JSON.stringify(dvi));
  } catch (err) {
    console.warn('dviOffline: saveDraft failed (quota?), skipping offline persistence', err);
  }
}
export function loadDraft(id: string): DviInspection | null {
  const raw = localStorage.getItem(DRAFT(id));
  return raw ? (JSON.parse(raw) as DviInspection) : null;
}
export function clearDraft(id: string): void {
  localStorage.removeItem(DRAFT(id));
}
export function markPending(id: string): void {
  const s = new Set(pendingIds());
  s.add(id);
  try {
    localStorage.setItem(PENDING, JSON.stringify([...s]));
  } catch (err) {
    console.warn('dviOffline: markPending failed (quota?)', err);
  }
}
export function unmarkPending(id: string): void {
  try {
    localStorage.setItem(PENDING, JSON.stringify(pendingIds().filter((x) => x !== id)));
  } catch (err) {
    console.warn('dviOffline: unmarkPending failed (quota?)', err);
  }
}
export function pendingIds(): string[] {
  const raw = localStorage.getItem(PENDING);
  return raw ? (JSON.parse(raw) as string[]) : [];
}
